import {css} from "@isceco/widget-library2/external/lit";

export default css`
    :host {
      display: flex;
      gap: var(--isceco-space-200);
      flex-wrap: wrap;
    }
`
